export const searchInputStyles = {
  width: '100%',
  maxWidth: '601px',
  minWidth: '200px',
  height: '40px',
  border: '1px solid #CDD6E0',
  borderRadius: '8px',
  margin: '0,4rem 0',

  fontFamily: 'Roboto, sans-serif',
  fontSize: 14,
  fontWeightRegular: 400,
  lineHeight: '22px',
};

export const helperTextStyles = {
  color: '#6F88A6',
  fontStyle: 'italic',
  whiteSpace: 'nowrap',
};

export const rateSheetFormControlsStyles = {
  display: 'flex',
  gap: '8px',
  justifyContent: 'flex-end',
};

// The filter row crowds once both toggles are present; the S/M/L/XL system
// (constants/ui) has no breakpoint near this width, so this view-local
// threshold widens the gap between the toggles when the row has room.
const WIDE_TOOLBAR_MIN_WIDTH = 1531;

export const filterTogglesStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,

  [`@media (min-width: ${WIDE_TOOLBAR_MIN_WIDTH}px)`]: {
    gap: 6,
  },
};
